import { useState } from "react";
import { Exercise } from "../../../models/Exercise";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { GET_SCHEDULE_DETAILS, GET_SCHEDULE_DETAILS_NOLOGIN, JOIN_TO_EXERCISE } from "../../../api/apiRoutes";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";

/* eslint-disable import/no-anonymous-default-export */
export default (exercise: Exercise, onRefreshExercises: () => void) => {
  const facilityIds = useFacility();
  const { get, post } = useApiRequest();
  const userDataId = useSelector((state: State) => state.auth.userData.objectId);
  const [exerciseDetails, setExerciseDetails] = useState<Exercise>(exercise);
  const [alerts, setAlerts] = useState<string>("");
  const [joinErrorData, setJoinErrorData] = useState<{ exerciseIds: string; passIds: string } | null>(null);
  const [showLoginButton, setShowLoginButton] = useState<boolean>(false);

  const getDetailsAboutExercise = async () => {
    const route = userDataId
      ? GET_SCHEDULE_DETAILS(facilityIds, `0,${exercise.objectId}`, `0,${userDataId}`)
      : GET_SCHEDULE_DETAILS_NOLOGIN(facilityIds, `0,${exercise.objectId}`);
    const { result, isError } = await get(route);
    if (!isError) {
      setExerciseDetails(result);
    }
  };

  const handleJoinToExercise = (assignType: boolean, passId: string) => {
    joinToExercise(exercise.objectId, assignType, passId, () => onJoinSuccess());
  };

  const onJoinSuccess = () => {
    setAlerts("");
    getDetailsAboutExercise();
    onRefreshExercises();
    setJoinErrorData(null);
    setShowLoginButton(false);
  };

  const joinToExercise = async (
    exerciseId: number | string,
    assigned: boolean,
    passId: string,
    onFinish: () => void
  ) => {
    const { isError, errorTable, result } = await post(JOIN_TO_EXERCISE(facilityIds, passId), {
      exerciseIds: exerciseId,
      webUserIds: `0,${userDataId}`,
      assigned: assigned,
    });

    if (!isError) {
      onFinish();
    } else {
      if (result && result.exerciseIds && result.passIds) {
        setJoinErrorData({ exerciseIds: result.exerciseIds, passIds: result.passIds });
      }
      const errorMessage = errorTable[0];
      setAlerts(errorMessage);
      if (errorMessage.toLowerCase().includes("zalogowany")) {
        setShowLoginButton(true);
      }
      setTimeout(() => {
        setJoinErrorData(null);
        setAlerts("");
        setShowLoginButton(false);
      }, 15000);
    }
  };

  const handleLeaveFromExercise = () => {
    if (joinErrorData) {
      joinToExercise(joinErrorData.exerciseIds, true, joinErrorData.passIds, () => onJoinSuccess());
    }
  };

  return { exerciseDetails, handleJoinToExercise, alerts, handleLeaveFromExercise, joinErrorData, showLoginButton };
};
